import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';
import { PhotoType } from '@/resources/enum/PhotoType';

export default {
  async upload(request: RequestUpload): Promise<AxiosResponse<ResponseUpload>> {
    const response: AxiosResponse<ResponseUpload> = await client.post<ResponseUpload>('my_number_doc_photos', request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async images(mnDocPhotoId: number): Promise<AxiosResponse<ResponseImages>> {
    const response: AxiosResponse<ResponseImages> = await client.get<ResponseImages>(
      `my_number_doc_photos/${mnDocPhotoId}/trimmed_images`,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async confirm(mnDocPhotoId: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `my_number_doc_photos/${mnDocPhotoId}/update_confirmed_result`,
      null,
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface RequestUpload {
  photoType: PhotoType;
  imageBase64: string;
}

export interface ResponseUpload {
  myNumberDocPhotoId: number;
}

export interface ResponseImages {
  trimmedImageBase64: string;
}
